import { Component, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import { CommonServiceService } from 'src/app/shared/common-service.service';
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from 'src/environments/environment';

import * as moment from 'moment-timezone';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subscription, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { GlobalVariable } from 'src/app/shared/global-variable';
import { DownloadService } from 'src/app/shared/download.service';
import { Tab } from 'src/app/shared/model/tab.model';
import { TabService } from 'src/app/shared/services/tab.service';
import { InvoiceComponent } from 'src/app/transactions/invoice/invoice.component';
import { InitialState } from 'src/app/store/reducer';
import { Store } from '@ngrx/store';
import { OpenAdvanceSearchModal } from 'src/app/transactions/store/actions';
import * as FileSaver from 'file-saver'
@Component({
	selector: 'app-e-inv-list',
	templateUrl: './e-inv-list.component.html',
	styleUrls: ['./e-inv-list.component.scss']
})
export class EInvListComponent implements OnInit {
	fromRoot = true;
	isPrint:any;
	selector: string = '.main-panel';
	fromIndex: any = 0;
	dataLimit: any = 100;
	toIndex: any = 30;
	allInvoiceArr: any;
	showPrintData : boolean = false;
	invoiceFilterForm: FormGroup;
	innerHeight: string;
	invoiceArr= [];
	clientArr: any;
	keyword = 'name';
	navigationSubscription
	reInitialise = false;
	p;
	valid: boolean;
	onSearch;
	onSearchFilter = new Subject<string>();

	isAdvancedSearchOpen: boolean = false;
	currentIndex = 0
	@ViewChild('tableHeader', { static: true }) tableHeader: ElementRef
	advancedSearchSubscription: Subscription;
	queryData: any;
	companyDetail: any;
	currentDate = new Date()
	loader: boolean = false;
	inv_duration: any;
	travel_duration: any;
	duration: any;
	queryParams: any;
	constructor(
		private formBuilder: FormBuilder,
		public commonService: CommonServiceService,
		private spinner: NgxSpinnerService,
		private route: ActivatedRoute,
		private router: Router,
		private downloadService: DownloadService,
		private tabService: TabService,
		private store: Store<InitialState>,
	) {

		this.navigationSubscription = this.router.events.subscribe((e: any) => {
			// If it is a NavigationEnd event re-initalise the component
			if (e instanceof NavigationEnd) {
				this.initialiseInvites();
			}
		});
	}

	ngOnInit() {

		let queryParams = JSON.parse(JSON.stringify(this.route.queryParams['value']))
		this.queryData = Object.assign({},queryParams)
		localStorage.setItem('activeE-inv-listQueryParams', JSON.stringify(queryParams))
		this.fromIndex = 0;
		queryParams['apply_limit'] = true
		queryParams['limit'] = 30;
        queryParams['offset'] = this.fromIndex;
		this.onSearch = ''
        this.search(queryParams)
		this.queryParams = queryParams
		this.reInitialise=true
		this.onSearchFilter.pipe(
			debounceTime(300),
			distinctUntilChanged())
			.subscribe(value => {
			  this.filterData(value)
		});


	}

	initialiseInvites() {
		if (this.reInitialise) {
			this.ngOnInit()
		}
	}

	ngAfterViewInit() {
		this.advancedSearchSubscription = this.commonService.advancedSearch.subscribe(status => {
			console.log('Is modal opened : ', status)
			// this.isAdvancedSearchOpen = status
		})
	}
	ngOnDestroy() {
		// avoid memory leaks here by cleaning up after ourselves. If we  
		// don't then we will continue to run our initialiseInvites()   
		// method on every navigationEnd event.
		if (this.navigationSubscription) {
			this.navigationSubscription.unsubscribe();
		}
		if (this.advancedSearchSubscription) {
			this.advancedSearchSubscription.unsubscribe()
		}
	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.setHeight(event.target.innerHeight)
	}


	setHeight(height) {
		if (this.invoiceArr != undefined) {
			if (height == undefined) {
				height = window.innerHeight
			}
			if (this.invoiceArr.length <= 9) {
				this.innerHeight = 'auto';
			}
			else {
				this.innerHeight = height - 180 + 'px';
			}
		}
	}

	async search(values) {
		let reqObj = Object.assign({},values)
		
		this.loader = true;
		let resp = await this.getData(reqObj)
		if(resp){
			this.loader = false;
			this.duration = resp['duration']
			this.invoiceArr = resp['data']
			this.allInvoiceArr = resp['data']
			this.focusOnTableHeader()
			this.currentIndex = 0
			this.setHeight(window.innerHeight)
			// this.commonService.selectedInput.next(1)
			let firstRow = document.getElementById('rowIndex_1') as HTMLElement
			if(firstRow){
				firstRow.scrollIntoView()
			}
		}
		
	}

	

	getData(values){
		return new Promise(async (resolve, reject) => {
			this.commonService.getRequestWithQueryParamsNoLoader(`${environment.okountUrl}/globalsearch/e-invoice-list`, values).subscribe(res => {
				resolve(res)
			},err=> {
				resolve(null)
			})
		})
	}

	async onScrollDown(event) {
		console.log('onScrollDown')
		this.fromIndex +=30
		// let toIndex = Number(this.toIndex) + 10
		let queryParams = JSON.parse(JSON.stringify(this.queryParams))
		queryParams['limit'] = 30;
		queryParams['offset'] = this.fromIndex;
		let resp = await this.getData(queryParams)
		if(resp){
			this.invoiceArr = this.invoiceArr.concat(resp['data'])
			this.setHeight(window.innerHeight)
		}
	}

	openAdvanceSearchModal(){
		this.store.dispatch(new OpenAdvanceSearchModal({status: true,title : 'e-inv-list'}));	
	}

	getLimitData(offset) {
		let url = `${environment.okountUrl}/globalsearch/e-invoice-list`
		let value = Object.assign({},this.queryData)
		this.loader = true;
		value['limit'] = this.dataLimit
		value['offset'] = offset
		value['apply_limit'] = true
		this.commonService.getRequestWithQueryParamsNoLoader(`${url}`, value).subscribe(res => {
			for (const key in res['data']) {
				if (Object.prototype.hasOwnProperty.call(res['data'], key)) {
					const element = res['data'][key];
					if (element != undefined) {
						// this.toIndex = i
						if (this.invoiceArr == undefined) {
							this.invoiceArr = []
						}
						this.invoiceArr.push(element)
					}
				}
			}
			this.loader = false;
			this.focusOnTableHeader()
			this.currentIndex = 0
			this.setHeight(window.innerHeight)
			this.valid = true

		})
	}

	// onScrollDown(event) {
	// 	this.fromIndex = this.fromIndex + this.dataLimit
	// 	let toIndex = Number(this.toIndex) + 30
	// 	this.getLimitData(this.fromIndex)
	// 	// for (let i = this.fromIndex; i <= toIndex; i++) {
	// 	// 	debugger
	// 	// 	const element = this.allInvoiceArr[i];
	// 	// 	if (element != undefined) {
	// 	// 		this.toIndex = i
	// 	// 		this.invoiceArr.push(element)
	// 	// 	}
	// 	// }
	// 	// this.toIndex = toIndex
	// }

	onScrollUp(event) {
	}

	openInvoice(invoice_number) {
		let path=`${environment.name == 'v3-stage' || environment.name == 'v3-prod' ? '/v3/' : "/"}#/transactions/invoice/view/${invoice_number}`

		if(window.location.protocol != 'file:'){
			if(invoice_number) {
				let title =''
				let newInvoiceParts = invoice_number.split('-')
				title += newInvoiceParts[0]
				title +='...'
				title += newInvoiceParts[newInvoiceParts.length-1]
				this.tabService.addTab(
					new Tab(InvoiceComponent, `${title}`, { invoice: invoice_number ,mode : 'view' }, invoice_number)
					);
			} else {
				window.open(path,'_blank')
			}
		}else{
			var customeEventHandler = new CustomEvent("handle-window-open", {
				"detail": {
					hashPath : path
				}
			  });
			window.dispatchEvent(customeEventHandler)
		}
	}

	focusOnTableHeader() {
		if (this.tableHeader != undefined) {
			this.tableHeader.nativeElement.focus()
		}
	}

	// @HostListener('window:keydown', ['$event'])
	onKeyDown(e: any) {
		console.log('openModalStatus : ' + GlobalVariable.openModalStatus)
		if (GlobalVariable.openModalStatus == false && GlobalVariable.openGlobalSearch == false) {
			if (e.keyCode == 40) {
				e.preventDefault();
				this.moveToNext()
			} else if (e.keyCode === 38) {
				e.preventDefault();
				this.moveToPrev()
			}
		}
	}
	moveToNext() {
		if (document.getElementById(`rowIndex_${this.currentIndex + 1}`) != null) {
			document.getElementById(`rowIndex_${this.currentIndex + 1}`).focus()
			this.currentIndex = this.currentIndex + 1
		}
	}
	moveToPrev() {
		if (document.getElementById(`rowIndex_${this.currentIndex - 1}`) != null) {
			document.getElementById(`rowIndex_${this.currentIndex - 1}`).focus()
			this.currentIndex = this.currentIndex - 1
		}
	}

	moveToIndex(i) {
		document.getElementById(`rowIndex_${i + 1}`).focus()
		this.currentIndex = i + 1
	}


	oldFilterData(value) {
		let tempArr = Object.assign([], this.allInvoiceArr)
		if (value.length >= 3) {
			let lowerCaseFilter = value.toLowerCase()
			let upperCaseFilter = value.toUpperCase()
			this.invoiceArr = tempArr.filter(
				invoiceData => {
					if ((
						invoiceData.affiliate_name != undefined &&
						invoiceData.affiliate_name != null &&
						(invoiceData.affiliate_name.includes(value) ||
							invoiceData.affiliate_name.includes(upperCaseFilter) ||
							invoiceData.affiliate_name.includes(lowerCaseFilter)
						)
					) ||
						(
							invoiceData.invoice_no != undefined &&
							invoiceData.invoice_no != null &&
							(
								invoiceData.invoice_no.includes(value) ||
								invoiceData.invoice_no.includes(upperCaseFilter) ||
								invoiceData.invoice_no.includes(lowerCaseFilter)
							)
						) ||
						(
							invoiceData.total != undefined &&
							invoiceData.total != null &&
							(
								invoiceData.total.toString().includes(value) ||
								invoiceData.total.toString().includes(upperCaseFilter) ||
								invoiceData.total.toString().includes(lowerCaseFilter)
							)
						) //Convert Number to string.

					) {
						return invoiceData
					}
					console.log(invoiceData)
				}
			)
			this.setHeight(window.innerHeight)
		} else {
			this.invoiceArr = []
			for (let i = 0; i <= 30; i++) {
				const element = this.allInvoiceArr[i];
				if (element != undefined) {
					this.toIndex = i
					this.invoiceArr.push(element)
				}
			}
			this.setHeight(window.innerHeight)
		}
	}

	async filterData(value) {
        if (value.length >= 0) {
            this.queryParams['freetext'] = value
            let queryParams = JSON.parse(JSON.stringify(this.queryParams))
            this.queryParams = queryParams
			this.fromIndex=0
            queryParams['limit'] = 30;
            queryParams['offset'] = this.fromIndex;
			this.loader = true
            let resp = await this.getData(queryParams)
			this.loader = false
            if(resp){
                this.invoiceArr = resp['data']
				this.duration = resp['duration']
				let firstRow = document.getElementById('rowIndex_1') as HTMLElement
				if(firstRow){
					firstRow.scrollIntoView()
				}

            }
           
        this.setHeight(window.innerHeight)
        } else {
            delete this.queryParams['freetext']
            this.search(this.queryParams)
            this.setHeight(window.innerHeight)
        }
    }


	async exportAsXLSX() {
		let Originaldata = await this.getAllData()
		let data: any = Originaldata['data']
		console.log("data",data)
		this.spinner.show()
		let xlsxData = [];
		data.forEach(data => {
		let newNarration = []
		newNarration.push(data['narration_1'])
		newNarration.push(data['narration_2'])
		newNarration.push(data['narration_3'])
		newNarration.push(data['narration_4'])
		newNarration.push(data['narration_5'])
		console.log("newNarration",newNarration)
		let newLineNarration = newNarration.join("\n")
			let obj = {};
			obj["INVOICE DATE"] = moment(data.invoice_date).format('DD/MM/YYYY')
			obj["Invoice No"] = data.invoice_no
			obj["Product Type"] = data.product_type 
			obj["Client"] = data.affiliate_name?data.affiliate_name:''
			obj["Narration"] = newLineNarration
			obj["Price"] = data.total 
			xlsxData.push(obj);
		});

		this.downloadService.exportAsXLSX(`E-Invoice List :`, xlsxData);
		this.spinner.hide()
	}

	getAllData() {
		this.loader = true;
		let queryParams = JSON.parse(localStorage.getItem("activeE-inv-listQueryParams"))
		return new Promise(async (resolve, reject) => {
		  this.commonService.getRequestWithQueryParamsNoLoader(`${environment.okountUrl}/globalsearch/e-invoice-list`, queryParams).subscribe(res => {
			  this.loader = false;
			  resolve(res)
		  
		  }, err => {
			resolve(null)
			this.loader = false;
		  })
		})
	  }

}
